module.exports = __webpack_public_path__ + "static/media/29EUNOG20.8a07fd3a.jpg";